
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import {
  ConfirmationDialogComponent,
  ConfirmationDialogProps,
} from 'src/app/shared/components/modals/confirmation-dialog/confirmation-dialog.component';
import { NotifyPlanNotificationTypes } from "../../../../services/models/enums";
import { NotificationResponseDto } from 'src/generated-sources/openapi/configuration-service/notification';

@Component({
    selector: 'app-notify-plan-change-dialog',
    templateUrl: './notify-plan-change-dialog.component.html',
    styleUrls: ['./notify-plan-change-dialog.component.scss'],
    imports: [ConfirmationDialogComponent, MatCheckboxModule, FormsModule]
})
export class NotifyPlanChangeDialogComponent {
  notificationType: NotifyPlanNotificationTypes;
  showAgain: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<NotifyPlanChangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { notification: NotificationResponseDto }
  ) {
    this.notificationType = data.notification?.type as NotifyPlanNotificationTypes;
  }

  props: ConfirmationDialogProps = {
    title: $localize`:@@attention:Atención`,
    confirmButton: {
      text: $localize`:@@confirm:Confirmar`,
      action: this.onConfirm.bind(this),
    },
    cancelButton: {
      hide: true,
    },
  };

  onConfirm() {
    this.dialogRef.close({ showAgain: this.showAgain });
  }

}
